import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { CustomerContextProvider } from '../../../context/customer-context';
import { QuoteView } from './quote-view';

export function initQuoteView() {
  const elements = document.getElementsByName('quote-view');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;

      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <QuoteView {...props} />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });
}
